import { Controller } from "stimulus"

// The time rows' counterpart to field-override: six selects (or three plus a length) that
// together are one value, compared against the series' time. Values arrive as "HH|MM|AM".
export default class extends Controller {
  static targets = ["startHour", "startMin", "startAmpm", "endHour", "endMin", "endAmpm", "length", "label"]
  static values = { start: String, end: String, length: String, seriesLabel: String }

  connect() {
    this.applyFieldStyle()
  }

  reset(event) {
    event.preventDefault()
    this.write([this.startHourTarget, this.startMinTarget, this.startAmpmTarget], this.startValue)
    if (this.hasLengthTarget) {
      this.lengthTarget.value = this.lengthValue
    } else {
      this.write([this.endHourTarget, this.endMinTarget, this.endAmpmTarget], this.endValue)
    }
    this.change()
  }

  change() {
    if (!this.hasLabelTarget) return
    if (this.overridden()) {
      this.labelTarget.innerHTML =
        '<span style="color: #3498db; font-weight: 600;">Overridden</span>' +
        ' <span style="color: #aaa;">series ' + this.seriesLabelValue + '</span>' +
        ' <a href="#" data-action="click->time-override#reset" style="color: #e74c3c; text-decoration: underline; margin-left: 4px;">Reset</a>'
    } else {
      this.labelTarget.innerHTML = '<span style="color: #aaa;">from series</span>'
    }
    this.applyFieldStyle()
  }

  overridden() {
    if (!this.startValue) return false
    const startDiffers = this.read([this.startHourTarget, this.startMinTarget, this.startAmpmTarget]) !== this.startValue
    const endDiffers = this.hasLengthTarget
      ? this.lengthTarget.value !== this.lengthValue
      : this.read([this.endHourTarget, this.endMinTarget, this.endAmpmTarget]) !== this.endValue
    return startDiffers || endDiffers
  }

  read(selects) { return selects.map(s => s.value).join("|") }

  write(selects, value) {
    value.split("|").forEach((part, i) => { selects[i].value = part })
  }

  applyFieldStyle() {
    if (!this.startValue) return
    const selects = [this.startHourTarget, this.startMinTarget, this.startAmpmTarget]
    if (this.hasLengthTarget) selects.push(this.lengthTarget)
    else selects.push(this.endHourTarget, this.endMinTarget, this.endAmpmTarget)
    const isOverridden = this.overridden()
    selects.forEach(el => {
      el.style.borderColor = isOverridden ? "#3498db" : ""
      el.style.backgroundColor = isOverridden ? "#eaf4fd" : ""
      el.style.color = isOverridden ? "#000" : "#aaa"
    })
  }
}
